import { withInstall } from '@hd-front-end/utils'
import Cascader from './src/cascader.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElCascader: SFCWithInstall<typeof Cascader> = withInstall(Cascader)

export default ElCascader

export * from './src/cascader'
export * from './src/instances'
